export type JobValidationErrors = {
  isRequisitionMissing: boolean;
  isApprovedRequisitionMissing: boolean;
  isActiveValidLocationMissing: boolean;
  isActiveLocationMissing: boolean;
  invalidEmploymentType: boolean;
  exceededLocationsLimit: boolean;
  formErrorType: JobValidationFormErrorType | null;
} | null;

export enum JobValidationFormErrorType {
  MissingRequiredFields = 'missingRequiredFields',
  MissingTitle = 'missingTitle',
  Default = 'default',
}
